import { service } from '@/utils/request'
export default {
	// -----------------AI问答明细-----------------
	// AI问答明细
	getAnswer(params) {
		return service({
			url: '/cloud/course/admin/aiQaInfo/pages',
			method: 'get',
			params: params
		})
	},
	// 详情
	detailAnswer(params) {
		return service({
			url: '/cloud/course/admin/aiQaInfo/details',
			method: 'get',
			params: params
		})
	},
	// AI问答明细导出
	exportExcel(params) {
		return service({
			url: '/cloud/course/admin/aiQaInfo/exportExcel',
			method: 'get',
			responseType: 'blob',
            params
		})
	},
	// 推荐点击明细分页查询
	recommendClickPages(params) {
		return service({
			url: '/cloud/course/admin/aiQaInfo/recommendClickPages',
			method: 'get',
			params: params
		})
	},
	// 用户分页查询
	userPages(params) {
		return service({
			url: '/cloud/course/admin/aiKeyword/userPages',
			method: 'get',
			params
		})
	},
	// 用户统计
	userStatistics(params) {
		return service({
			url: '/cloud/course/admin/aiKeyword/userStatistics',
			method: 'get',
			params
		})
	},

	// -----------------问答关键词-----------------

    // 问答关键词
	getKey(params) {
		return service({
			url: '/cloud/course/admin/aiKeyword/pages',
			method: 'get',
			params: params
		})
	},
	// 详情
	detailKey(params) {
		return service({
			url: '/cloud/course/admin/aiKeyword/details',
			method: 'get',
			params
		})
	},
	addKey(data) {
		return service({
			url: '/cloud/course/admin/aiKeyword/save',
			method: 'post',
			data
		})
	},
	removeKey(params) {
		return service({
			url: '/cloud/course/admin/aiKeyword/delete',
			method: 'post',
			params
		})
	},
	statusKey(params) {
		return service({
			url: '/cloud/course/admin/aiKeyword/changeState',
			method: 'post',
			params
		})
	},
	// 用户分页查询
	userPagesKey(params) {
		return service({
			url: '/cloud/course/admin/aiKeyword/userPages',
			method: 'get',
			params
		})
	},
	// 用户统计
	userStatisticsKey(params) {
		return service({
			url: '/cloud/course/admin/aiKeyword/userStatistics',
			method: 'get',
			params
		})
	},
	exportExcelKey(params) {
		return service({
			url: '/cloud/course/admin/aiKeyword/exportExcel',
			method: 'get',
			responseType: 'blob',
            params
		})
	},


    // 推荐页配置
	getRecommend(params) {
		return service({
			url: '/cloud/course/admin/aiPageSetting/pages',
			method: 'get',
			params: params
		})
	},
	detailRecommend(params) {
		return service({
			url: '/cloud/course/admin/aiPageSetting/details',
			method: 'get',
			params: params
		})
	},
	addRecommend(data) {
		return service({
			url: '/cloud/course/admin/aiPageSetting/save',
			method: 'post',
			data
		})
	},
	removeRecommend(params) {
		return service({
			url: '/cloud/course/admin/aiPageSetting/delete',
			method: 'post',
			params: params
		})
	},
	statusRecommend(params) {
		return service({
			url: '/cloud/course/admin/aiPageSetting/changeState',
			method: 'post',
			params: params
		})
	},
	// 用户分页查询
	userPagesRecommend(params) {
		return service({
			url: '/cloud/course/admin/aiPageSetting/userPages',
			method: 'get',
			params
		})
	},
	// 用户统计
	userStatisticsRecommend(params) {
		return service({
			url: '/cloud/course/admin/aiPageSetting/userStatistics',
			method: 'get',
			params
		})
	},
	// AI导出
	exportExcelRecommend(params) {
		return service({
			url: '/cloud/course/admin/aiPageSetting/exportExcel',
			method: 'get',
			responseType: 'blob',
            params
		})
	},


    // 权益配置
    getRights(params, data) {
		return service({
			url: '/cloud/course/admin/aiLimitSetting/page',
			method: 'post',
			params: params,
			data
		})
	},
	detailRights(id) {
		return service({
			url: '/cloud/course/admin/aiLimitSetting/detail/' + id,
			method: 'get'
		})
	},
	addRights(data) {
		return service({
			url: '/cloud/course/admin/aiLimitSetting/add',
			method: 'post',
			data
		})
	},
	editRights(data) {
		return service({
			url: '/cloud/course/admin/aiLimitSetting/edit',
			method: 'post',
			data
		})
	},
	removeRights(id) {
		return service({
			url: '/cloud/course/admin/aiLimitSetting/disable/' + id,
			method: 'post'
		})
	},
    addGuide(params) {
		return service({
			url: '/cloud/course/admin/aiLimitSetting/memberGuide',
			method: 'get',
			params
		})
	},
	getGuide() {
		return service({
			url: '/cloud/course/api/aiLimitSetting/memberGuide',
			method: 'get'
		})
	},

    // 浮窗配置
    getWindow(params) {
		return service({
			url: '/cloud/bbs/admin/floatWindow/pages',
			method: 'get',
			params: params
		})
	},
	detailWindow(params) {
		return service({
			url: '/cloud/bbs/admin/floatWindow/details',
			method: 'get',
			params: params
		})
	},
	addWindow(data) {
		return service({
			url: '/cloud/bbs/admin/floatWindow/save',
			method: 'post',
			data
		})
	},
	removeWindow(params) {
		return service({
			url: '/cloud/bbs/admin/floatWindow/delete',
			method: 'post',
			params: params
		})
	},
	// 用户分页查询
	userPagesWindow(params) {
		return service({
			url: '/cloud/bbs/admin/floatWindow/userPages',
			method: 'get',
			params
		})
	},
	// 用户统计
	userStatisticsWindow(params) {
		return service({
			url: '/cloud/bbs/admin/floatWindow/userStatistics',
			method: 'get',
			params
		})
	},
	statusWindow(params) {
		return service({
			url: '/cloud/bbs/admin/floatWindow/changeState',
			method: 'post',
			params
		})
	},
	exportWindow(params) {
		return service({
			url: '/cloud/bbs/admin/floatWindow/exportExcel',
			method: 'get',
			responseType: 'blob',
            params
		})
	},
}


// WEBPACK FOOTER //
// ./src/api/operateManage/AIManage.js